// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/wafers/wafers.scss
// module id = 33
// module chunks = 0